import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { CbFormFieldComponent } from '../cb-form-field/cb-form-field.component';
import { CbFormButton, CbOptionsFormColumn, CbStandardForm } from '../cb-form-interfaces';

@Component({
  selector: 'cb-form',
  templateUrl: './cb-form.component.html',
  styleUrls: ['./cb-form.component.scss']
})
export class CbFormComponent implements OnInit {
  public title = '';

  @Input() public showButtons: boolean = true;

  @Input() public form!: CbStandardForm;
  @Input() public data?: any;

  @Output() public submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() public delete: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(CbFormFieldComponent) public fields!: QueryList<CbFormFieldComponent>;

  public values: { [key: string]: any } = {};
  public isLoading = true;

  public hasErrors = false;

  private additionalData: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.title = this.form.title;
    this.form = this.form;

    this.additionalData = this.data;

    if (this.form.defaultObj) {
      this.values = this.form.defaultObj;
    } else {
      this.initForm();
    }

    this.checkAutoGeneratedOptions().then(() => {
      this.isLoading = false;
    });
  }

  private initForm(): void {
    for (const row of this.form.rows) {
      for (const col of row.columns) {
        this.values[col.field] = col.defaultValue;
      }
    }
  }


  public change(): void {
    // Checks if some values have to be disabled
    // according to the conditions stated in the conditionalDisable object
    if (this.form.conditionalDisable) {
      for (const key in this.form.conditionalDisable) {
        for (const row of this.form.rows) {
          for (const col of row.columns) {
            if (col.field === key) {
              col.disabled = this.form.conditionalDisable[key](this.values);
            }
          }
        }
      }
    }

    this.checkAutoGeneratedOptions().then(() => {
      if (this.hasErrors) {
        this.checkForErrors();
      }
    });

  }

  private async checkAutoGeneratedOptions(): Promise<void> {
    // Check for select inputs with auto-generated options
    for (const row of this.form.rows) {
      for (const col of row.columns) {
        if (["options", "multioptions"].includes(col.type)) {
          const select: CbOptionsFormColumn = col as CbOptionsFormColumn;
          if (select.dynamic) {
            let active = true;
            // If the values of the dependencies are not set, the options are disabled
            if (select.dynamic.dependsOn.length > 0) {
              for (const dep of select.dynamic.dependsOn) {
                if (!this.values[dep]) {
                  active = false;
                }
              }
            }

            // If active then generate the options
            if (active) {
              select.options = await select.dynamic.optionsGenerator(this.values, this.additionalData);
            } else {
              col.disabled = true;
            }
          }
        }
      }
    }
  }

  public buttonClick(button: CbFormButton): void {
    if (button.onClick) button.onClick(this.values);
  }

  private async checkForErrors(): Promise<void> {
    this.hasErrors = false;

    for (const field of this.fields.toArray()) {
      if (await field.checkForErrors(this.values)) {
        this.hasErrors = true;
        return;
      }
    }


  }

  public async submitClick(): Promise<void> {
    await this.checkForErrors();

    if (!this.hasErrors) {
      if (this.form.submitButton?.onClick)
        this.form.submitButton.onClick(this.values);
      this.submit.emit(this.values);
    }
  }

  public async deleteClick(): Promise<void> {
    if (this.form.deleteButton?.onClick)
      this.form.deleteButton.onClick(this.values);
    this.delete.emit(this.values);
  }
}
